import { motion, useInView } from "framer-motion"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const ImageCardGrid = ({ module }) => {
  const ref = useRef(null)
  const isInView = useInView(ref)
  const [hasPlayed, setHasPlayed] = useState(false)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])
  if (module.hideSection === "no") {
    return (
      <section className="bg-white-100">
        <motion.div
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`explore-cards relative pt-40 lgscreen:pt-30 pb-[110px] lgscreen:pb-30${
            module.extraClass ? ` ${module.extraClass}` : " "
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-xl relative"
          >
            <div className="flex flex-wrap -mx-15 lgscreen:mx-0 gap-y-8">
              {module.cards &&
                module.cards.map((item, index) => (
                  <motion.div
                    variants={animFade}
                    className="lg:w-6/12 w-full px-15 lgscreen:px-0"
                    key={index}
                  >
                    <div className="cards group">
                      <div className="img relative">
                        {item?.image && (
                          <Link
                            to={item.button.url}
                            target={item.button.target}
                          >
                            <div className="img-overlay absolute top-0 left-0 h-full w-full z-10 bg-[#000000]/0 group-hover:bg-[#000000]/[0.15] transition-all duration-150 ease-out"></div>
                            <ImageOpt
                              imgData={item.image.mediaItemUrl}
                              width={1000}
                              height={800}
                              imgAlt={item.image.altText}
                              imgLoad="lazy"
                            />
                          </Link>
                        )}
                      </div>
                      <div className="cards-content text-center w-[445px] mx-auto lgscreen:w-full pt-30">
                        {item?.preHeading && (
                          <div className="preheading lgscreen:mb-15">
                            <motion.div
                              variants={animFade}
                              className="font-ositalic text-16"
                            >
                              {item.preHeading}
                            </motion.div>
                          </div>
                        )}
                        {item?.heading && (
                          <motion.h2 variants={animFade}>
                            {item.heading}
                          </motion.h2>
                        )}
                        {item?.description && (
                          <motion.div
                            variants={animFade}
                            className="content lgscreen:pt-15"
                          >
                            {parse(item.description)}
                          </motion.div>
                        )}
                        {item?.button && (
                          <motion.div
                            variants={animFade}
                            className="mt-30 lgscreen:mt-20"
                          >
                            <Link
                              to={item.button.url}
                              className="btn btn-border"
                              target={item.button.target}
                            >
                              {item.button.title}
                            </Link>
                          </motion.div>
                        )}
                      </div>
                    </div>
                  </motion.div>
                ))}
            </div>
          </motion.div>
        </motion.div>
      </section>
    )
  }
  return null
}

export default ImageCardGrid
export const PageImageCardGridFragment = graphql`
  fragment PageImageCardGridFragment on WpPage_Pagecontent_PageContent_ImageCardGrid {
    extraId
    extraClass
    hideSection
    cards {
      preHeading
      heading
      description
      button {
        target
        title
        url
      }
      image {
        altText
        mediaItemUrl
      }
    }
  }
`
